import React from "react";
import styles from "./HomeFive.module.css";

import {FaLessThan} from 'react-icons/fa';
import {FaGreaterThan} from 'react-icons/fa'

import stars from '../../assets/images/Star.svg';
import cont from '../../assets/images/cont.png'


const data2=[
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
]


export default function HomeFour() {
  return (

      <div className={styles.aboutUs}>
        <div className={styles.mobilec}>
          <h1 className={styles.heading2}>What Are People Saying About Us</h1>
        </div>
          {/* <div className={styles.signs}>
              <FaLessThan size={28}    className={styles.icons}  />
              <FaGreaterThan size={28} className={styles.icons} />
          </div> */}
          <div className={styles.cards2}>
          {data2.map((value, index) => (
            <div className={styles.card2} key={index}>
              <div className={styles.mobileW}>
                <h1 className={styles.name2}>
                  {value.name}
                </h1>
                <p className={styles.des2}>
                  {value.des}
                </p>
                <div className={styles.stars}>
                  <img src={stars} alt="Stars"  />
                </div>
                <div className={styles.center}>
                  <img src={cont} alt={value.rname} className={styles.rimage}/>
                  <div>
                    <h1 className={styles.rname}>{value.rname}</h1>
                    <p className={styles.rdes}>{value.rdes}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
  );
}
